import React from 'react';
import { Box, TextField, Button, Typography, FormControl, Select, MenuItem } from '@mui/material';
import { createServiceContractDelegationService } from '../../../../Domain/Services/ServiceContractDelegation/CreateServiceContractDelegationService';
import { getServiceContractDelegation } from '../../../../Domain/Services/ServiceContractDelegation/GetServiceContractDelegationService';
import { patchServiceContractDelegationService } from '../../../../Domain/Services/ServiceContractDelegation/PatchServiceContractDelegationService';
import { getUnionDelegationServiceListService } from '../../../../Domain/Services/UnionDelegationService/GetUnionDelegationServiceListService';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { useTranslation } from 'react-i18next';
import { PRIVATE_USER_LIST_CONTRACT_DELEGATION_SERVICE, PRIVATE_USER_LIST_DELEGATION_SERVICE } from '../../../Constants/PathsConstants';
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import PropTypes from "prop-types";
import InputLabel from "@mui/material/InputLabel";
import { toast } from 'react-toastify';
import { useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import { getServiceCompanyListService } from 'DelegationService/DelegationService/Domain/Services/ServiceCompany/GetServiceCompanyListService';
import { getDelegationList } from 'Delegation/Domain/Services/GetDelegationListService';
import { createServiceContactDelegationService } from 'DelegationService/DelegationService/Domain/Services/ServiceContactDelegation/CreateServiceContactDelegationService';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { DELEGADO_DELEGACIONES_SERVICIOS, GESTOR_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';





FormServiceContractDelegationView.propTypes = {
    id: PropTypes.string,
    onClose: PropTypes.func,
};

function FormServiceContractDelegationView({ onClose }) {
    const { t } = useTranslation();

    const { id } = useParams();
    const [unionId, setUnionId] = React.useState("");
    const [serviceCompanyId, setServiceCompanyId] = React.useState("");
    const [delegationId, setDelegationId] = React.useState("");
    const [serviceContractDelegationName, setServiceContractDelegationName] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const [startDate, setStartDate] = React.useState("");
    const [sendingApiRequest, setSendingApiRequest] = React.useState(false);
    const [unionDelegationService, setUnionDelegationService] = React.useState([]);
    const [serviceCompany, setServiceCompany] = React.useState([]);
    const [delegation, setDelegation] = React.useState([]);
    const [executionDate, setExecutionDate] = React.useState("");
    const formatDate = (datetimeString) => datetimeString?.split(" ")[0] || "";
    const navigate = useNavigate();
    const { checkPermission } = useAuthContext();
    const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
    const [hasDelegadoPermission, setHasDelegadoPermission] = React.useState(false);
    console.log(hasAdminPermission);
    console.log(hasDelegadoPermission);
    React.useEffect(() => {

        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);
        const delegado = checkPermission(DELEGADO_DELEGACIONES_SERVICIOS);
        setHasDelegadoPermission(delegado);
        setHasAdminPermission(admin);

        if (!admin && !delegado) {
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, { replace: true });
        }
    }, [checkPermission, navigate]);

    // Qué necesito?
    // Un lugar donde guardar los componentes formulario activos
    const [contactForms, setContactForms] = React.useState([]);
    // Un lugar para que cada componente de formulario guarde sus datos
    const contactFormsData = React.useRef({});


    const resetForm = () => {
        setServiceContractDelegationName("");
        setExecutionDate("");
        setStartDate("");
        setEndDate("");
    };

    const generateUUID = () => {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    };

    const handleChange = (e) => {
        // e.target es el elemento javascript vanilla que tiene el atributo data-uuid
        console.log(e.target.dataset.uuid);
        // Descubrir qué campo ha sido modificado
        console.log(e.target.name);
        // Descubrir el valor
        console.log(e.target.value); // OK!
        // Actualizar contactFormsData
        // INICIO COPIA DE LOS DATOS QUE HAY AHORA MISMO
        var actualContactFormsData = {};
        for (const [key, element] of Object.entries(contactFormsData.current)) {
            actualContactFormsData[key] = element;
        }
        // A PARTIR DE AQUI PUEDO MODIFICAR
        // HACER AQUI LAS COAS
        actualContactFormsData[e.target.dataset.uuid][e.target.name] = e.target.value,
            console.log(contactFormsData.current);


        // AQUI LE DOY LA ACTUALIZACION A REACT
        contactFormsData.current = actualContactFormsData;
    };

    const agregarFormularioContacto = () => {
        // Generamos el identificador del formulario
        var uuid = generateUUID();
        // Creamos su estructura de datos, la del componente que acabamos de agregar arriba
        var actualContactFormsData = {};
        for (const [key, element] of Object.entries(contactFormsData.current)) {
            actualContactFormsData[key] = element;
        }
        actualContactFormsData[uuid] = {
            'nombre': '',
            'apellido': '',
            'correoElectronico': '',
            'telefono': ''
        };
        // Agregamos el formulario (El componente en la constante)
        var actualContactForms = [];
        contactForms.map((element) => {
            actualContactForms.push(element);
        });
        actualContactForms.push((
            <Box key={uuid} sx={{
                minHeight: '20vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 3,
                px: 2,
                mt: 2,
            }}>
                <TextField
                    label={t('Nombre')}
                    required
                    inputProps={{ 'data-uuid': uuid }}
                    name="nombre"
                    onChange={handleChange}
                ></TextField>
                <TextField
                    required
                    label={t('Apellido')}
                    inputProps={{ 'data-uuid': uuid }}
                    name="apellido"
                    onChange={handleChange}
                ></TextField>

                <TextField
                    label={t('Correo Electronico')}
                    required
                    type= "email"
                    inputProps={{ 'data-uuid': uuid }}
                    name="correoElectronico"
                    onChange={handleChange}
                ></TextField>
                <TextField
                    label={t('Telefono')}
                    required
                    inputProps={{ 'data-uuid': uuid }}
                    name="telefono"
                    onChange={handleChange}
                ></TextField>

            </Box>

        ));
        contactFormsData.current = actualContactFormsData;
        setContactForms(actualContactForms);

    };

    React.useEffect(() => {
        getUnionDelegationServiceListService()
            .then((response) => {
                if (Array.isArray(response.records)) {
                    setUnionDelegationService(response.records);
                } else {
                    console.error("Expected array, got:", response);
                    setUnionDelegationService([]);
                }
            });
        getServiceCompanyListService()
            .then((response) => {
                if (Array.isArray(response.records)) {
                    setServiceCompany(response.records);
                } else {
                    console.error("Expected array, got:", response);
                    setServiceCompany([]);
                }
            });
        getDelegationList()
            .then((response) => {
                if (Array.isArray(response.records)) {
                    setDelegation(response.records);
                } else {
                    setDelegation([]);
                }
            })
            .catch((error) => {
                toast.error(t("unionDelegationService.table.no_data"));
                console.error("Error fetching union list", error);
                setUnionDelegationService([]);
                setServiceCompany([]);
                setDelegation([]);
            });
    }, []);

    React.useEffect(() => {
        if (!id || id === "new") {
            resetForm();
            return;
        }

        setSendingApiRequest(true);

        getServiceContractDelegation(id)
            .then((response) => {
                if (response && response.name) {
                    setServiceContractDelegationName(response.name);
                    setUnionId(response.unionId);
                    setServiceCompanyId(response.serviceCompanyId);
                    setDelegationId(response.delegationId);
                    setExecutionDate(formatDate(response.executionDate));
                    setStartDate(formatDate(response.startDate));
                    setEndDate(formatDate(response.endDate));
                } else {
                    setServiceContractDelegationName("");
                }
            }).catch((error) => {
                toast.error(t("serviceContractDelegation.restore.error"));
                console.error("Error fetching service contract delegation", error);
                setServiceContractDelegationName("");
            }).finally(() => {
                setSendingApiRequest(false);
            });
    }, [id]);

    const handleServiceContractDelegationNameChange = (event) => setServiceContractDelegationName(event.target.value);
    const handleUnionIdChange = (event) => setUnionId(event.target.value);
    const handleServiceCompanyChange = (event) => setServiceCompanyId(event.target.value);
    const handleDelegationChange = (event) => setDelegationId(event.target.value);
    const handleStartDateChange = (event) => setStartDate(event.target.value);
    const handleEndDateChange = (event) => setEndDate(event.target.value);
    const handleExecutionDateChange = (event) => setExecutionDate(event.target.value);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (sendingApiRequest) return;
        setSendingApiRequest(true);

        try {
            let contractResponse = null;
            if (endDate < startDate) {
                toast.error(t("service.ContractDelegation.date.error"));
                return;
            }
            if ((executionDate < startDate || executionDate > endDate) && executionDate !== "") {
                toast.error(t("service.ContractDelegation.dateExecution.error"));
                return;
            }
            if (id === "new") {
                contractResponse = await createServiceContractDelegationService({
                    name: serviceContractDelegationName,
                    unionServiceDelegationId: parseInt(unionId, 10), // Convert to integer
                    serviceCompanyId: parseInt(serviceCompanyId, 10),
                    delegationId: parseInt(delegationId, 10),
                    executionDate: executionDate === "" ? null : executionDate,
                    startDate: startDate,
                    endDate: endDate

                });
                // Hacerlo X veces, una por cada contacto creado
                for (const [indiceContacto, contacto] of Object.entries(contactFormsData.current)) {
                    console.log(indiceContacto);
                    await createServiceContactDelegationService({
                        name: contacto.nombre,
                        serviceContractDelegationId: parseInt(contractResponse.id),
                        apellido: contacto.apellido,
                        correoElectronico: contacto.correoElectronico,
                        contactPhoneNumber: contacto.telefono
                    });
                }
                console.log("Respuesta real de createServiceContractDelegationService:", contractResponse);
            } else {
                contractResponse = await patchServiceContractDelegationService(id, {
                    name: serviceContractDelegationName,
                    unionServiceDelegationId: parseInt(unionId, 10), // Convert to integer
                    serviceCompanyId: parseInt(serviceCompanyId, 10),
                    delegationId: parseInt(delegationId, 10),
                    executionDate: executionDate === "" ? null: executionDate,
                    startDate: startDate,
                    endDate: endDate
                });
            }
            if (contractResponse !== null) {
                toast.success(t("serviceContractDelegation.restore.success"));
                window.location.href = process.env.PUBLIC_URL + PRIVATE_USER_LIST_CONTRACT_DELEGATION_SERVICE;
            };
        } catch (error) {
            console.error("Error creating or updating service contract delegation", error);
        } finally {
            console.log("No enviando la peticion"),
                setSendingApiRequest(false);
        }
    };


    return (
        <>
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    minHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 3,
                    px: 2,
                }}
            >
                <Typography variant="h4" textAlign="center">
                    {id === "new" ? t('serviceContractDelegation.form.create') : t('serviceContractDelegation.form.update')}
                </Typography>
                {hasDelegadoPermission && (
                    <TextField
                        label={t('serviceContractDelegation.table.executionDate')}
                        variant="outlined"
                        type="date"
                        value={executionDate}
                        onChange={handleExecutionDateChange}
                        sx={{ width: "100%", maxWidth: 400 }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                )}

                {hasAdminPermission && (
                    <>
                        <TextField
                            required
                            label={t('serviceContractDelegation.form.serviceContractDelegationName')}
                            variant="outlined"
                            value={serviceContractDelegationName}
                            onChange={handleServiceContractDelegationNameChange}
                            sx={{ width: "100%", maxWidth: 400 }}
                        />
                        <FormControl sx={{ width: "100%", maxWidth: 400 }}>
                            <InputLabel>{t('serviceContractDelegation.form.unionName')}</InputLabel>
                            <Select
                                required
                                value={unionId !== undefined && unionId !== null ? unionId : ""}
                                onChange={handleUnionIdChange}
                                label={t('serviceContractDelegation.form.unionName')}
                            >
                                {unionDelegationService.map((union) => (
                                    <MenuItem key={union.id} value={union.id}>
                                        {union.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: "100%", maxWidth: 400 }}>
                            <InputLabel>{t('serviceCompany.form.serviceCompanyName')}</InputLabel>
                            <Select
                                required
                                value={serviceCompanyId !== undefined && serviceCompanyId !== null ? serviceCompanyId : ""}
                                onChange={handleServiceCompanyChange}
                                label={t('serviceCompany.form.serviceCompanyName')}
                            >
                                {serviceCompany.map((serviceCompany) => (
                                    <MenuItem key={serviceCompany.id} value={serviceCompany.id}>
                                        {serviceCompany.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: "100%", maxWidth: 400 }}>
                            <InputLabel>{t('delegation.form.delegationName')}</InputLabel>
                            <Select
                                required
                                value={delegationId !== undefined && delegationId !== null ? delegationId : ""}
                                onChange={handleDelegationChange}
                                label={t('delegation.form.delegationName')}
                            >
                                {delegation.map((delegation) => (
                                    <MenuItem key={delegation.id} value={delegation.id}>
                                        {delegation.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            required
                            label={t('serviceContractDelegation.table.startDate')}
                            variant="outlined"
                            type="date"
                            value={startDate}
                            onChange={handleStartDateChange}
                            sx={{ width: "100%", maxWidth: 400 }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            required
                            label={t('serviceContractDelegation.table.endDate')}
                            variant="outlined"
                            type="date"
                            value={endDate}
                            onChange={handleEndDateChange}
                            sx={{ width: "100%", maxWidth: 400 }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        {id === "new" && (
                            <Box>
                                <Typography>Contactos</Typography>
                                <Button
                                    onClick={() => {
                                        agregarFormularioContacto();
                                    }}
                                >
                                    Agregar Contacto
                                </Button>
                                <Box>
                                    {contactForms}
                                </Box>
                            </Box>

                        )}
                    </>
                )}

                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                    <Button
                        variant='contained'
                        onClick={onClose}
                        color='error'
                        component={RouterLink}
                        to={PRIVATE_USER_LIST_CONTRACT_DELEGATION_SERVICE}
                        startIcon={<CancelIcon />}
                        sx={{
                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none',
                        }}
                    >
                        {t('serviceContractDelegation.form.cancel')}

                    </Button>

                    <Button
                        variant="contained"
                        type="submit"
                        startIcon={<SaveIcon />}
                        sx={{
                            backgroundColor: "#0492D4",
                            color: "white",

                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none',
                            "&:hover": {
                                backgroundColor: "#037bb5",
                            },
                        }}

                    >
                        {id === "new" ? t('serviceContractDelegation.form.create') : t('serviceContractDelegation.form.update')}
                    </Button>

                </Box>
            </Box>

            <DialogLoader open={sendingApiRequest} />
        </>
    );
}

export default FormServiceContractDelegationView;